import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import {AuthService} from '../../shared/services/auth.services';


export const RoleGuard: CanActivateFn = async (route, _state) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  if (route.data['roles']) {
    const userRoles = authService.getRoles();
    // Verificar se o usuário tem pelo menos uma das permissões necessárias
    return userRoles.filter((role) => {
      return route.data['roles'].includes(role)
    }).length > 0;
  }
  router.navigate(['home'])
  return false
}
